import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExportButtons = _resolveComponent("ExportButtons")!

  return (_openBlock(), _createBlock(_component_ExportButtons, {
    class: "dashboards-filter__export-buttons",
    loading: _ctx.isLoading,
    onExportPptx: _ctx.downloadPptx,
    onExportPdf: _ctx.downloadPDF,
    exportTypes: ['pptx', 'pdf']
  }, null, 8, ["loading", "onExportPptx", "onExportPdf"]))
}